// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"ErrorFallback-module-errorWrapper--Gyo9Z","errorContainer":"ErrorFallback-module-errorContainer--yq21M"};